<div formGroupName="bikoranForm">
    <mat-card class="cur-card">
        <mat-card-content>
            <div class="tw-flex tw-flex-col">
                <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>備考欄</mat-label>
                    <textarea matInput formControlName="biko" style="resize: none;width: 100%;" rows="3"
                        maxlength="75"></textarea>
                </mat-form-field>
            </div>
        </mat-card-content>
    </mat-card>
</div>